import { Component, input, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import {
	VehicleModelSearchDto,
	VehicleModelsFilters,
} from '@splitsecondconnect/ultramarine-shared';

import { BaseSearchableNewComponent } from '../../../../../../../shared/base-classes/base-searchable-new.component';
import { SearchableFieldComponent } from '../../../../../../../shared/components/searchable-field/searchable-field.component';
import { SelectItem } from '../../../../../../../shared/models/select-item.type';
import { SEARCHABLE_STRATEGY_TOKEN } from '../../../../../../../shared/tokens/searchable-strategy.token';
import { VehicleModelSearchStrategy } from '../../../../config/vehicle-models-searchable-strategy';

@Component({
	selector: 'app-model-searchable',
	template: `
		<app-searchable-field
			[label]="label()"
			[formControl]="searchableId"
			[filters]="filters()"></app-searchable-field>
	`,
	imports: [ReactiveFormsModule, SearchableFieldComponent],
	host: {
		class: 'w-full',
	},
	providers: [
		{
			provide: SEARCHABLE_STRATEGY_TOKEN,
			useClass: VehicleModelSearchStrategy,
		},
	],
})
export class ModelSaerchableComponent extends BaseSearchableNewComponent<
	SelectItem<VehicleModelSearchDto>,
	VehicleModelsFilters
> {
	@Input() searchableId: FormControl;
	label = input<string>();
}
